// Questions for the sample-data mode. The real questions live on the server (QuestionnaireLoader.java);
// keep the two in step if you change either.
export const QUESTION_BANK = [
  {
    "code": "IMP-0",
    "section": "IMP",
    "sectionTitle": "Business impact",
    "prompt": "Does this application influence decisions about people, money, or regulated activity?",
    "help": "Answer No if it only supports internal convenience work such as drafting or searching non-sensitive material.",
    "appliesTo": null,
    "gate": true,
    "gateCode": null,
    "weight": 0,
    "riskWhen": "YES",
    "minTier": null
  },
  {
    "code": "IMP-1",
    "section": "IMP",
    "sectionTitle": "Business impact",
    "prompt": "Does it recommend, rank, score or flag people, claims, cases or transactions for action?",
    "help": null,
    "appliesTo": null,
    "gate": false,
    "gateCode": "IMP-0",
    "weight": 3,
    "riskWhen": "YES",
    "minTier": null
  },
  {
    "code": "IMP-2",
    "section": "IMP",
    "sectionTitle": "Business impact",
    "prompt": "Can its output take effect with no human review beforehand?",
    "help": "Answer Yes if a person does not look at the result before it is acted on.",
    "appliesTo": null,
    "gate": false,
    "gateCode": "IMP-0",
    "weight": 5,
    "riskWhen": "YES",
    "minTier": "TIER_3"
  },
  {
    "code": "IMP-3",
    "section": "IMP",
    "sectionTitle": "Business impact",
    "prompt": "Could a wrong output delay, reduce or deny someone's access to care, a benefit or a service?",
    "help": null,
    "appliesTo": null,
    "gate": false,
    "gateCode": "IMP-0",
    "weight": 5,
    "riskWhen": "YES",
    "minTier": "TIER_2"
  },
  {
    "code": "IMP-4",
    "section": "IMP",
    "sectionTitle": "Business impact",
    "prompt": "Could a wrong output change a payment, price, reserve or contract commitment above your approval threshold?",
    "help": null,
    "appliesTo": null,
    "gate": false,
    "gateCode": "IMP-0",
    "weight": 4,
    "riskWhen": "YES",
    "minTier": null
  },
  {
    "code": "IMP-5",
    "section": "IMP",
    "sectionTitle": "Business impact",
    "prompt": "Could a failure require notifying a regulator, auditor or affected individuals?",
    "help": null,
    "appliesTo": null,
    "gate": false,
    "gateCode": "IMP-0",
    "weight": 4,
    "riskWhen": "YES",
    "minTier": "TIER_2"
  },
  {
    "code": "DAT-0",
    "section": "DAT",
    "sectionTitle": "Data handled",
    "prompt": "Does the application receive or produce any non-public data?",
    "help": "Public marketing content only is a No.",
    "appliesTo": null,
    "gate": true,
    "gateCode": null,
    "weight": 0,
    "riskWhen": "YES",
    "minTier": null
  },
  {
    "code": "DAT-1",
    "section": "DAT",
    "sectionTitle": "Data handled",
    "prompt": "Does it handle health information or other specially regulated personal data?",
    "help": null,
    "appliesTo": null,
    "gate": false,
    "gateCode": "DAT-0",
    "weight": 5,
    "riskWhen": "YES",
    "minTier": "TIER_2"
  },
  {
    "code": "DAT-2",
    "section": "DAT",
    "sectionTitle": "Data handled",
    "prompt": "Does it handle personal data about customers, members, patients or employees?",
    "help": null,
    "appliesTo": null,
    "gate": false,
    "gateCode": "DAT-0",
    "weight": 3,
    "riskWhen": "YES",
    "minTier": null
  },
  {
    "code": "DAT-3",
    "section": "DAT",
    "sectionTitle": "Data handled",
    "prompt": "Is any of our data kept by the model or the provider beyond the single request (training, tuning, long-term memory)?",
    "help": null,
    "appliesTo": null,
    "gate": false,
    "gateCode": "DAT-0",
    "weight": 4,
    "riskWhen": "YES",
    "minTier": null
  },
  {
    "code": "DAT-4",
    "section": "DAT",
    "sectionTitle": "Data handled",
    "prompt": "Does data leave company-controlled environments?",
    "help": "Include API calls to hosted models and file transfers to a provider.",
    "appliesTo": null,
    "gate": false,
    "gateCode": "DAT-0",
    "weight": 3,
    "riskWhen": "YES",
    "minTier": null
  },
  {
    "code": "DAT-5",
    "section": "DAT",
    "sectionTitle": "Data handled",
    "prompt": "Are retention and deletion periods defined for inputs, outputs and logs?",
    "help": null,
    "appliesTo": null,
    "gate": false,
    "gateCode": "DAT-0",
    "weight": 3,
    "riskWhen": "NO",
    "minTier": null
  },
  {
    "code": "MDL-0",
    "section": "MDL",
    "sectionTitle": "Model behaviour",
    "prompt": "Does the application use machine learning or generative AI?",
    "help": "Rules-only automation is a No.",
    "appliesTo": null,
    "gate": true,
    "gateCode": null,
    "weight": 0,
    "riskWhen": "YES",
    "minTier": null
  },
  {
    "code": "MDL-1",
    "section": "MDL",
    "sectionTitle": "Model behaviour",
    "prompt": "Does generative AI produce content that customers, members or the public will see?",
    "help": null,
    "appliesTo": null,
    "gate": false,
    "gateCode": "MDL-0",
    "weight": 4,
    "riskWhen": "YES",
    "minTier": null
  },
  {
    "code": "MDL-2",
    "section": "MDL",
    "sectionTitle": "Model behaviour",
    "prompt": "Can the model's behaviour change without our review, for example through provider updates?",
    "help": null,
    "appliesTo": null,
    "gate": false,
    "gateCode": "MDL-0",
    "weight": 3,
    "riskWhen": "YES",
    "minTier": null
  },
  {
    "code": "MDL-3",
    "section": "MDL",
    "sectionTitle": "Model behaviour",
    "prompt": "Was accuracy tested on data that represents our real cases before go-live?",
    "help": null,
    "appliesTo": null,
    "gate": false,
    "gateCode": "MDL-0",
    "weight": 4,
    "riskWhen": "NO",
    "minTier": null
  },
  {
    "code": "MDL-4",
    "section": "MDL",
    "sectionTitle": "Model behaviour",
    "prompt": "Did testing compare results across different groups of people?",
    "help": null,
    "appliesTo": null,
    "gate": false,
    "gateCode": "MDL-0",
    "weight": 4,
    "riskWhen": "NO",
    "minTier": null
  },
  {
    "code": "MDL-5",
    "section": "MDL",
    "sectionTitle": "Model behaviour",
    "prompt": "Is performance watched after launch, with a trigger for action if it degrades?",
    "help": null,
    "appliesTo": null,
    "gate": false,
    "gateCode": "MDL-0",
    "weight": 3,
    "riskWhen": "NO",
    "minTier": null
  },
  {
    "code": "MDL-6",
    "section": "MDL",
    "sectionTitle": "Model behaviour",
    "prompt": "Can a person affected by an output, or an auditor, be given a clear reason for it?",
    "help": null,
    "appliesTo": null,
    "gate": false,
    "gateCode": "MDL-0",
    "weight": 3,
    "riskWhen": "NO",
    "minTier": null
  },
  {
    "code": "OPS-1",
    "section": "OPS",
    "sectionTitle": "Security and operations",
    "prompt": "Is access through single sign-on with role-based permissions?",
    "help": null,
    "appliesTo": null,
    "gate": false,
    "gateCode": null,
    "weight": 3,
    "riskWhen": "NO",
    "minTier": null
  },
  {
    "code": "OPS-2",
    "section": "OPS",
    "sectionTitle": "Security and operations",
    "prompt": "Are user and system actions logged and kept for a defined period?",
    "help": null,
    "appliesTo": null,
    "gate": false,
    "gateCode": null,
    "weight": 3,
    "riskWhen": "NO",
    "minTier": null
  },
  {
    "code": "OPS-3",
    "section": "OPS",
    "sectionTitle": "Security and operations",
    "prompt": "Is there a tested way to switch the application off or roll it back?",
    "help": null,
    "appliesTo": null,
    "gate": false,
    "gateCode": null,
    "weight": 3,
    "riskWhen": "NO",
    "minTier": null
  },
  {
    "code": "OPS-4",
    "section": "OPS",
    "sectionTitle": "Security and operations",
    "prompt": "Is there a named owner and a named backup?",
    "help": null,
    "appliesTo": null,
    "gate": false,
    "gateCode": null,
    "weight": 2,
    "riskWhen": "NO",
    "minTier": null
  },
  {
    "code": "VND-1",
    "section": "VND",
    "sectionTitle": "Vendor controls",
    "prompt": "Do we hold a current independent security report (such as SOC 2 or ISO 27001) dated within 12 months?",
    "help": null,
    "appliesTo": "VENDOR",
    "gate": false,
    "gateCode": null,
    "weight": 4,
    "riskWhen": "NO",
    "minTier": null
  },
  {
    "code": "VND-2",
    "section": "VND",
    "sectionTitle": "Vendor controls",
    "prompt": "Does the contract stop the vendor from using our data to train its own models?",
    "help": null,
    "appliesTo": "VENDOR",
    "gate": false,
    "gateCode": null,
    "weight": 5,
    "riskWhen": "NO",
    "minTier": "TIER_2"
  },
  {
    "code": "VND-3",
    "section": "VND",
    "sectionTitle": "Vendor controls",
    "prompt": "Are the vendor's subprocessors disclosed and approved by us?",
    "help": null,
    "appliesTo": "VENDOR",
    "gate": false,
    "gateCode": null,
    "weight": 3,
    "riskWhen": "NO",
    "minTier": null
  },
  {
    "code": "VND-4",
    "section": "VND",
    "sectionTitle": "Vendor controls",
    "prompt": "Does the contract set a deadline for the vendor to tell us about a breach?",
    "help": null,
    "appliesTo": "VENDOR",
    "gate": false,
    "gateCode": null,
    "weight": 4,
    "riskWhen": "NO",
    "minTier": null
  },
  {
    "code": "VND-5",
    "section": "VND",
    "sectionTitle": "Vendor controls",
    "prompt": "Do we know where our data is stored and processed, and is that location acceptable?",
    "help": null,
    "appliesTo": "VENDOR",
    "gate": false,
    "gateCode": null,
    "weight": 3,
    "riskWhen": "NO",
    "minTier": null
  },
  {
    "code": "VND-6",
    "section": "VND",
    "sectionTitle": "Vendor controls",
    "prompt": "Is there an exit plan covering data return and deletion if we end the contract?",
    "help": null,
    "appliesTo": "VENDOR",
    "gate": false,
    "gateCode": null,
    "weight": 2,
    "riskWhen": "NO",
    "minTier": null
  },
  {
    "code": "VND-7",
    "section": "VND",
    "sectionTitle": "Vendor controls",
    "prompt": "Will the vendor warn us before it changes AI features or models?",
    "help": null,
    "appliesTo": "VENDOR",
    "gate": false,
    "gateCode": null,
    "weight": 3,
    "riskWhen": "NO",
    "minTier": null
  },
  {
    "code": "BLD-1",
    "section": "BLD",
    "sectionTitle": "Build controls",
    "prompt": "Are code, prompts and model versions kept in a controlled repository with approved changes?",
    "help": null,
    "appliesTo": "INTERNAL",
    "gate": false,
    "gateCode": null,
    "weight": 3,
    "riskWhen": "NO",
    "minTier": null
  },
  {
    "code": "BLD-2",
    "section": "BLD",
    "sectionTitle": "Build controls",
    "prompt": "Are the sources of training or reference data documented?",
    "help": null,
    "appliesTo": "INTERNAL",
    "gate": false,
    "gateCode": null,
    "weight": 3,
    "riskWhen": "NO",
    "minTier": null
  },
  {
    "code": "BLD-3",
    "section": "BLD",
    "sectionTitle": "Build controls",
    "prompt": "Does someone outside the build team review it before each release?",
    "help": null,
    "appliesTo": "INTERNAL",
    "gate": false,
    "gateCode": null,
    "weight": 3,
    "riskWhen": "NO",
    "minTier": null
  },
  {
    "code": "BLD-4",
    "section": "BLD",
    "sectionTitle": "Build controls",
    "prompt": "Has it been tested against misuse, such as attempts to override its instructions?",
    "help": null,
    "appliesTo": "INTERNAL",
    "gate": false,
    "gateCode": null,
    "weight": 3,
    "riskWhen": "NO",
    "minTier": null
  }
];
